export type FieldStatus = 'neutral' | 'error' | 'success' | 'warning'

export type FieldFeedbackInput = {
  error?: string
  helperText?: string
  message?: string
  status?: FieldStatus
}

export function resolveFieldFeedback({ error, helperText, message, status }: FieldFeedbackInput) {
  const resolvedMessage = error ?? message ?? helperText
  const resolvedStatus: FieldStatus = error ? 'error' : (status ?? 'neutral')

  return {
    invalid: resolvedStatus === 'error',
    message: resolvedMessage,
    status: resolvedStatus,
  }
}
